/* Copyright (c) Trimble Inc. All rights reserved. */
import {Box, Button, CircularProgress, createStyles, DialogProps, makeStyles} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle, IconButton} from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";
import NotificationActionsDialogComponents from "./NotificationActionsDialogComponents";
import { TextAreaContainer } from "modus/components/form/textarea-container/TextAreaContainer";
import { NotificationActionsProps } from "./TeamNotificationActions";
import TeamApprovalServices from "../../services/TeamApprovalService";
import { useAsyncAction } from "modus/components/form/async-actions/AsyncAction";
import { Alert } from "@material-ui/lab";
import { resolveAPIErrorMessage } from "modus/components/error-message/ErrorMessage";
import { MY_TEAM_KEY } from "header/team-selector/TeamSelector";
import { useSelector } from "react-redux";

export const DenyTeam: React.FC<NotificationActionsProps> = ({
  notification,
  refreshApprovals
}) => {
  const [open, setOpen] = React.useState(false);
  const [disabled, setDisabled] = useState(true);
  const [formValues, setFormValues] = useState({
    reason: "",
  });
  const [hasFieldError, setHasFieldError] = useState(false); // New state to track child component validation error
  const handleSetError = (value: boolean) => {
    setHasFieldError(value);
    setDisabled(value);
  };
  const useStyles = makeStyles(() => {
    return createStyles({
      header: {
        position: "relative",
      },
      dialog: {
        overflowX: "hidden",
      },
    });
  });

  const handleClickOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setOpen(true);
  };

  const handleClose = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setOpen(false);
    setFormValues({
      reason: "",
    });
    
  };
  const teamId = useSelector((state: any) =>notification?.resource?.name ?? state?.teamManager?.teams?.currentTeam?.id ?? sessionStorage.getItem(MY_TEAM_KEY));

  const { state, subscribe } = useAsyncAction(() =>
    TeamApprovalServices.denyTeamRequest(teamId, formValues.reason, notification.requestedBy?.emailAddress ?? "")
  );

    const handleSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!hasFieldError || formValues.reason !== "") {
      subscribe();
      setTimeout(() => {
        handleClose(event);
        refreshApprovals();
      }, 3000);
    }
  };
 
  const [maxWidth] = useState<DialogProps["maxWidth"]>("sm");
  const style = useStyles();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <>
      <Button
        style={{ border: "1px solid black", color: "black" }}
        onClick={handleClickOpen}
      >
        Deny
      </Button>
      <Dialog
        fullWidth={true}
        maxWidth={maxWidth}
        open={open}
        onClose={handleClose}
        onClick={(event: React.MouseEvent<HTMLDivElement>) => event.stopPropagation()}
        classes={{
          paper: style.dialog,
        }}
      >
        <DialogTitle>
          New Member Request Review
          <IconButton
            aria-label="close"
            onClick={handleClose}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {state?.error && (
            <Alert severity="error">
              {resolveAPIErrorMessage(state?.error)}
            </Alert>
          )}
          {!state?.error && state?.status === "LOADED" && (
            <Alert severity="success">Have removed this request</Alert>
          )}
          <NotificationActionsDialogComponents notification={notification} refreshApprovals={refreshApprovals}/>

          <TextAreaContainer
            label={"Reason"}
            name={"reason"}
            required
            value={formValues.reason}
            placeholder={"Add a reason for rejecting the Member Request"}
            onChange={handleChange}
            setError={handleSetError}
            validate={{
              maxLength: 500,
              required: true,
            }}
          ></TextAreaContainer>
        </DialogContent>
        <DialogActions>
          <Box p={2}>
            <Button
              onClick={handleSubmit}
              style={{ backgroundColor: "#DA212C", color: "#ffffff" }}
              variant="contained"
              disabled={disabled || state?.loading }
            >
              {state?.loading && <CircularProgress className="action-loader" />}
              Reject
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DenyTeam;
